// =============== plugin import =============== //
import {useState, useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
// ============== component import ================ //
import ProductFeatureAssociationForm from './component/ProductFeatureAssociationForm';
import ProductFeatureAssociationList from './component/ProductFeatureAssociationList';
const ProductFeatureAssociation = (props) => {
    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;
    const {
        formValidateError,
        formData, 
        productIsChange, 
        featureIsChange
    } = props;

    // ------- define all state here --------- //
    const [ associationDataState, setAssociationDataState ] = useState({});
    const[associationStateIsChange, setAssociationStateIsChange] = useState(false);

    const [isButtonLoader, setIsButtonLoader] = useState(false);

    const associationSaveHandler = (associationData) => {
        setAssociationStateIsChange(true)
        setIsButtonLoader(true)
        const assManage = Object.keys(associationData).reduce((acc, key, index) => {
            acc[key] = {
                feature_list: associationData[key],
                index: index,
            };
            return acc;
        }, {});
        const updatedState = { ...associationDataState, ...assManage };
        setAssociationDataState(updatedState);
        props.onInputChange('step3', 'product_features_association', updatedState);
    }

    const associationDeleteHandler = (productName) => {
        setAssociationStateIsChange(true)
        // -------- delete product_features_association_data -------- //
        const pfAssData = formData['step3'].product_features_association_data;
        if(pfAssData.length > 0){
            const filterProductData = (data, productToRemove) => {
                return data
                .map((item) => ({
                ...item,
                select_association: item.select_association.filter(
                    (assoc) => !assoc.value.includes(`Product: ${productToRemove}`)
                ),
                }))
                .filter((item) => item.select_association.length > 0);
            };
            const pfAssDataUpdate =  filterProductData(pfAssData, productName);
            props.onInputChange('step3', 'product_features_association_data', pfAssDataUpdate);
            props.productFeatureAssChange(true)
        }
        // --------- delete product_features_association --------- //
        const updatedAssociationData = { ...associationDataState };
        delete updatedAssociationData[productName];
        setAssociationDataState(updatedAssociationData)
        props.onInputChange(
            'step3',
            'product_features_association',
            updatedAssociationData
        );
    }

    useEffect(() => {
        setAssociationStateIsChange(false)
        setAssociationDataState(formData['step3'].product_features_association)
    },[formData['step3']]);

    const infoPopupData = {
        'product_features_association' : {
            'title' : 'Product features association',
            'info' : 'Use this to match the Features with the Products that you have created.',
        },
    }
    const infoOpenOnCLick = (param) => {
        props.isInfoOpenHandler({
            type: 'open',
            data: infoPopupData[param]
        })
    }

    // ---------- association api call ---------- //
    useEffect(() => {
        const saveAssociationDetails = async () => {
            if (!associationStateIsChange && !productIsChange && !featureIsChange) return;
            const saveFeatureData = async () => {
                const updatedState = Object.keys(associationDataState).reduce((acc, key, index) => {
                    const existingData = associationDataState[key]; 
                    acc[key] = {
                        feature_list: Array.isArray(existingData.feature_list) ? existingData.feature_list : existingData, 
                        index: index,
                    };
                    return acc;
                }, {});

                let apiToken = '';
                if(loginUserType === 'A'){
                    apiToken = localStorage.getItem('token')
                }
                else if(loginUserType === 'D'){
                    apiToken = localStorage.getItem('developertoken')
                }
                else if(loginUserType === 'SA') {
                    apiToken = localStorage.getItem('systemAdminToken')
                }
                let associationFormData = new FormData();
                associationFormData.append("action_type", 'product_feature_association_setup');
                associationFormData.append("bot_id", formData.bot_id);
                associationFormData.append("step", "step3");
                associationFormData.append("data", JSON.stringify(updatedState));
                associationFormData.append("sass_id", localStorage.getItem('sass_id'));
                associationFormData.append("user_type", localStorage.getItem('type'));
                associationFormData.append("user_name", loginUserType == 'SA' ? localStorage.getItem('system_username') : '');
                const apiHeaders = {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "x-access-token": apiToken,
                    },
                };
                try {
                    await axios.post(`${api_base_url}api/save-bot-details`, associationFormData, apiHeaders)
                    .then(async (res) => {
                        if(res.data.status === 'success'){
                            associationFormData = new FormData();
                            setAssociationStateIsChange(false)
                            props.isRefresh(false)
                            setIsButtonLoader(false)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                } catch (error) {
                    console.error("Error during save:", error);
                }
            }
            await saveFeatureData();
        }
        saveAssociationDetails();
    },[associationDataState, productIsChange, featureIsChange])

    return (
        <>
            {
                formData['step3'].product_setup.length > 0 &&
                <div className='row border border-dashed border-gray-400 rounded p-5 mb-5'>
                    <div className='col-md-6'>
                        <a className="fw-bold text-gray-800 mb-2 fs-3">
                            Product Feature/Selection Association
                        </a>
                    </div>
                    <div className='col-md-6 text-end'>
                        <span className=''>
                            <FontAwesomeIcon
                                icon={faCircleInfo}
                                className='cursor-pointer text-gray-600'
                                onClick={(e) => infoOpenOnCLick('product_features_association')}
                            />
                        </span>
                    </div>
                    <div className='col-md-12'>
                        <ProductFeatureAssociationForm
                            formValidateError = {formValidateError}
                            formData={formData}
                            associationSave={associationSaveHandler}
                            isButtonLoader={isButtonLoader}
                        />
                    </div>
                    <div className='col-md-12'>
                        <ProductFeatureAssociationList
                            associationData={associationDataState}
                            associationDelete={associationDeleteHandler}
                        />
                    </div>
                </div>
            }
        </>
    )
}

export default ProductFeatureAssociation
